var render = function () {
  var _vm$program, _vm$program$thumb, _vm$program2, _vm$program3, _vm$program4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auction-halls-program"
  }, [_c('div', {
    staticClass: "image-card",
    style: 'background-image:url(' + ((_vm$program = _vm.program) === null || _vm$program === void 0 ? void 0 : (_vm$program$thumb = _vm$program.thumb) === null || _vm$program$thumb === void 0 ? void 0 : _vm$program$thumb.url) + ');'
  }, [_c('div', {
    staticClass: "image-card__inner"
  }, [_c('div', {
    staticClass: "image-card__con"
  }, [_c('h3', {
    staticClass: "image-card__tit"
  }, [_vm._v(_vm._s((_vm$program2 = _vm.program) === null || _vm$program2 === void 0 ? void 0 : _vm$program2.subject))]), _c('div', {
    staticClass: "image-card__info"
  }, [_c('ul', [_vm.at ? _c('li', [_c('strong', [_vm._v("일시")]), _c('span', [_vm._v(_vm._s(_vm.at))])]) : _vm._e(), _vm.duration ? _c('li', [_c('strong', [_vm._v("기간")]), _c('span', [_vm._v(_vm._s(_vm.duration))])]) : _vm._e(), ((_vm$program3 = _vm.program) === null || _vm$program3 === void 0 ? void 0 : _vm$program3.location) ? _c('li', [_c('strong', [_vm._v("장소")]), _c('span', [_vm._v(_vm._s((_vm$program4 = _vm.program) === null || _vm$program4 === void 0 ? void 0 : _vm$program4.location))])]) : _vm._e()])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }